<template>
  <div
    v-if="installmentDetails.installments.length > 0"
    class="installment-list"
  >
    <h1>
      {{ title }}
    </h1>
    <ul>
      <li
        v-for="installment in installmentDetails.installments"
        :key="installment.amount"
      >
        <CardItem
          :title="computeTermLabel(t, te, installment.term)"
          :right-text="computedAmountValue(installment.amount)"
          :right-text-bold="true"
          @click="handleSelectInstallment(installment)"
        />
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import {computed, defineComponent, PropType, ref, watchEffect} from "vue";
import CardItem from "@/components/CardItem.vue";
import {useI18n} from "vue-i18n";
import {IInstallment} from "@/types/IInstallment";
import {useStore} from "vuex";
import { computedAmountValue, computeTermLabel } from "@/shared-helpers/language.helper";

export default defineComponent({
  name: "InstallmentsList",
  components: {
    CardItem,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    installmentDetails: {
      type: Object as PropType<IInstallment>,
      required: true,
      default: () => ({
        currencySymbol: "",
        country: "",
        currency: "",
        installments: [],
      }),
    },
  },
  emits: ["select-installment-item"],
  setup(props) {
    const { t,  te } = useI18n();
    const store = useStore();
    const currencySymbol = computed(
      () => props.installmentDetails.currencySymbol
    );

    const sortedInstallments = ref([...props.installmentDetails.installments]);

    watchEffect(() => {
      if (currencySymbol.value) {
        store.dispatch("payOptions/setCurrencySymbol", currencySymbol.value);
      }
      // Sort the local copy of installments based on the amount field
      sortedInstallments.value = [...props.installmentDetails.installments].sort((a, b) => a.amount - b.amount);
    });

    return {
      computedAmountValue,
      computeTermLabel,
      t,
      te,
      sortedInstallments,
    };
  },
  methods: {
    handleSelectInstallment(selectedInstallmentItem) {
      this.$emit("select-installment-item", selectedInstallmentItem);
    },
  },
});
</script>

<style scoped>
.installment-list {
  padding: 16px 16px 150px 16px;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.installment-list h1 {
  color: #333;
  font-family: "Inter", sans-serif;
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: -0.26px;
  margin: 0;
}

.installment-list ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.animation-container {
  justify-content: center;
  align-items: center;
  flex: 1;
  display: flex;
}

.animation-container h4 {
  color: var(--Typography-Text-1);
  font-feature-settings: "clig" off, "liga" off;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 26px;
  margin: auto;
}

.loading-animation {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: auto;
}
</style>
